const K8ProgramPreferencesSetupViewContainer = () => {
  return null
}

export default K8ProgramPreferencesSetupViewContainer
